import * as Api from "@modules/api";
import { thunkErrorHandler } from "@utils/helpers/thunkErrorHandler";
import { thunkResponseCheckerSdk } from "@utils/helpers/thunkResponseCheckerSdk";
import { ApiMethod } from "@utils/types/common";

export const contactUs: ApiMethod<
  Api.Server.ContactUsInput,
  void,
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(
        async () => {
          const client = new Api.Server.Server_ContactUs_Client(
            undefined,
            Api.apiClient
          );

          return client.contactUs_post_V1(body);
        },
        rejectWithValue,
        false
      );
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};
